/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { DeliveryMethodEnumType } from "./DeliveryMethodEnum"
import { NotificationDateFormatEnumType } from "./NotificationDateFormatEnum"
import { NotificationTimeFormatEnumType } from "./NotificationTimeFormatEnum"
import { NotificationTypeSettingsDtoModel, NotificationTypeSettingsDtoModelType } from "./NotificationTypeSettingsDtoModel"
import { NotificationTypeSettingsDtoModelSelector } from "./NotificationTypeSettingsDtoModel.base"
import { RootStoreType } from "./index"


/**
 * CustomerNotificationOrganizationSettingsDtoBase
 * auto generated base class for the model CustomerNotificationOrganizationSettingsDtoModel.
 */
export const CustomerNotificationOrganizationSettingsDtoModelBase = ModelBase
  .named('CustomerNotificationOrganizationSettingsDto')
  .props({
    __typename: types.optional(types.literal("CustomerNotificationOrganizationSettingsDto"), "CustomerNotificationOrganizationSettingsDto"),
    etaWindowMinutesBefore: types.union(types.undefined, types.integer),
    etaWindowMinutesAfter: types.union(types.undefined, types.integer),
    driverOnTheWayThreshold: types.union(types.undefined, types.integer),
    deliveryScheduledThreshold: types.union(types.undefined, types.null, types.integer),
    deliveryMethod: types.union(types.undefined, DeliveryMethodEnumType),
    allowSms: types.union(types.undefined, types.boolean),
    etaTrackingLink: types.union(types.undefined, types.boolean),
    onTheWayTrackingLink: types.union(types.undefined, types.boolean),
    deliveredTrackingLink: types.union(types.undefined, types.boolean),
    missedTrackingLink: types.union(types.undefined, types.boolean),
    replyToEmail: types.union(types.undefined, types.string),
    deliveryScheduled: types.union(types.undefined, types.late((): any => NotificationTypeSettingsDtoModel)),
    onTheWay: types.union(types.undefined, types.late((): any => NotificationTypeSettingsDtoModel)),
    successfulDelivery: types.union(types.undefined, types.late((): any => NotificationTypeSettingsDtoModel)),
    missedDelivery: types.union(types.undefined, types.late((): any => NotificationTypeSettingsDtoModel)),
    cancelledDelivery: types.union(types.undefined, types.late((): any => NotificationTypeSettingsDtoModel)),
    businessName: types.union(types.undefined, types.null, types.string),
    phoneNumber: types.union(types.undefined, types.null, types.string),
    address: types.union(types.undefined, types.null, types.string),
    fromName: types.union(types.undefined, types.null, types.string),
    dateFormat: types.union(types.undefined, types.null, NotificationDateFormatEnumType),
    timeFormat: types.union(types.undefined, types.null, NotificationTimeFormatEnumType),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CustomerNotificationOrganizationSettingsDtoModelSelector extends QueryBuilder {
  get etaWindowMinutesBefore() { return this.__attr(`etaWindowMinutesBefore`) }
  get etaWindowMinutesAfter() { return this.__attr(`etaWindowMinutesAfter`) }
  get driverOnTheWayThreshold() { return this.__attr(`driverOnTheWayThreshold`) }
  get deliveryScheduledThreshold() { return this.__attr(`deliveryScheduledThreshold`) }
  get deliveryMethod() { return this.__attr(`deliveryMethod`) }
  get allowSms() { return this.__attr(`allowSms`) }
  get etaTrackingLink() { return this.__attr(`etaTrackingLink`) }
  get onTheWayTrackingLink() { return this.__attr(`onTheWayTrackingLink`) }
  get deliveredTrackingLink() { return this.__attr(`deliveredTrackingLink`) }
  get missedTrackingLink() { return this.__attr(`missedTrackingLink`) }
  get replyToEmail() { return this.__attr(`replyToEmail`) }
  get businessName() { return this.__attr(`businessName`) }
  get phoneNumber() { return this.__attr(`phoneNumber`) }
  get address() { return this.__attr(`address`) }
  get fromName() { return this.__attr(`fromName`) }
  get dateFormat() { return this.__attr(`dateFormat`) }
  get timeFormat() { return this.__attr(`timeFormat`) }
  deliveryScheduled(builder: string | NotificationTypeSettingsDtoModelSelector | ((selector: NotificationTypeSettingsDtoModelSelector) => NotificationTypeSettingsDtoModelSelector) | undefined) { return this.__child(`deliveryScheduled`, NotificationTypeSettingsDtoModelSelector, builder) }
  onTheWay(builder: string | NotificationTypeSettingsDtoModelSelector | ((selector: NotificationTypeSettingsDtoModelSelector) => NotificationTypeSettingsDtoModelSelector) | undefined) { return this.__child(`onTheWay`, NotificationTypeSettingsDtoModelSelector, builder) }
  successfulDelivery(builder: string | NotificationTypeSettingsDtoModelSelector | ((selector: NotificationTypeSettingsDtoModelSelector) => NotificationTypeSettingsDtoModelSelector) | undefined) { return this.__child(`successfulDelivery`, NotificationTypeSettingsDtoModelSelector, builder) }
  missedDelivery(builder: string | NotificationTypeSettingsDtoModelSelector | ((selector: NotificationTypeSettingsDtoModelSelector) => NotificationTypeSettingsDtoModelSelector) | undefined) { return this.__child(`missedDelivery`, NotificationTypeSettingsDtoModelSelector, builder) }
  cancelledDelivery(builder: string | NotificationTypeSettingsDtoModelSelector | ((selector: NotificationTypeSettingsDtoModelSelector) => NotificationTypeSettingsDtoModelSelector) | undefined) { return this.__child(`cancelledDelivery`, NotificationTypeSettingsDtoModelSelector, builder) }
}
export function selectFromCustomerNotificationOrganizationSettingsDto() {
  return new CustomerNotificationOrganizationSettingsDtoModelSelector()
}

export const customerNotificationOrganizationSettingsDtoModelPrimitives = selectFromCustomerNotificationOrganizationSettingsDto().etaWindowMinutesBefore.etaWindowMinutesAfter.driverOnTheWayThreshold.deliveryScheduledThreshold.deliveryMethod.allowSms.etaTrackingLink.onTheWayTrackingLink.deliveredTrackingLink.missedTrackingLink.replyToEmail.businessName.phoneNumber.address.fromName.dateFormat.timeFormat
